import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import router from './router'
import 'nprogress/nprogress.css'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  vuetify,
  created () {
    const userString = localStorage.getItem('user') // On recupère dans le localstorage l'utilisateur
    if (userString) { // s'il existe
      const userData = JSON.parse(userString) // on converti la chaine en objet
      this.$store.commit('SET_USER_DATA', userData) // et on le stocke dans le VueX
    }
    axios.interceptors.response.use( // On ajoute un interceptors à Axio pour qu'il nous déconnecte en cas d'erreur 401
        response => response,
        error => {
          if (error.response.status === 401) {
            this.$store.dispatch('logout')
          }
          return Promise.reject(error)
        }
    )
  },
  render: h => h(App)
}).$mount('#app')
